import { SET_STOCK_API_STATE, RECEIVE_STOCK_LEVELS, RECEIVE_STOCK_DETAIL } from '../constants/ActionTypes';

const initial = { records: [], details: {}, apiState: "init" };

const stock = (state = initial, action) => {
  switch (action.type) {
    case SET_STOCK_API_STATE:
      return { ...state, apiState: action.apiState };
    case RECEIVE_STOCK_LEVELS:
      return { ...state, records: action.levels, apiState: "ready" };
    case RECEIVE_STOCK_DETAIL:
      return {
        ...state,
        details: { ...state.details, [action.mealId]: action.entries }
      };
    default:
      return state;
  }
};

export default stock;
